import { Component, OnDestroy, OnInit, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  KontaktTableDto,
  MagacinDto,
  PoslovnaJedinicaTableDto,
  SaldoStrankaDto,
  StrankaClient,
  StrankaInfoDto,
  SubscriptionPackage,
  TipPristupa,
  TipRacuna,
  VrstaRacuna,
} from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';
import {
  DynamicDialogConfig,
  DynamicDialogService,
} from '@kodit/core/shared-ui';
import {
  DialogSize,
  OnDynamicDialogTypedInit,
} from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SlanjePodsetnikaFormComponent } from '../slanje-podsetnika-form/slanje-podsetnika-form.component';
import { RacunFilterService } from '../../../../../shared-subforms/src/lib/racun/racun-filter/racun-filter.service';
import { SelectItem } from 'primeng/api';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kodit-stranka-info',
  templateUrl: './stranka-info.component.html',
  styleUrls: ['./stranka-info.component.scss'],
})
export class StrankaInfoComponent
  implements
    OnInit,
    OnDestroy,
    OnDynamicDialogTypedInit<SlanjePodsetnikaFormComponent> {
  private _subs: Subscription = new Subscription();

  /** Configurations */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  /** Props */
  strankaInfoDto: StrankaInfoDto;
  activeIndex: number = 0;
  avansniRacun: TipRacuna = TipRacuna.AVANSNI_RACUN;
  poslovneJedinice: PoslovnaJedinicaTableDto[] = [];
  saldoStrankaDto: SaldoStrankaDto;
  strankaId: number;
  kontaktTable: KontaktTableDto[] = [];
  magacinDto: MagacinDto;
  innerWidth: any;
  vrstaStrankeOptions: SelectItem[] = [];
  vrstaStrankeCtrl: FormControl = new FormControl(VrstaRacuna.IZLAZNI);

  /** Conditionals props */
  hasBesplatniPaket: boolean = false;
  shouldDisplayDobavljac: boolean;
  shouldDisplayPrimljeniAvans: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _dialogService: DynamicDialogService,
    private _client: StrankaClient,
    private _breadcrumbService: BreadcrumbService,
    public authService: AuthService,
    private _racunFilterService: RacunFilterService
  ) {
    this.strankaInfoDto = new StrankaInfoDto();
  }

  ngOnInit(): void {
    this.hasBesplatniPaket =
      this.authService.hasPackage(SubscriptionPackage[SubscriptionPackage.BESPLATNO]) &&
      !this.authService.hasPackage(SubscriptionPackage[SubscriptionPackage.ROOT]);
      this.shouldDisplayPrimljeniAvans = this.authService.hasClaim([
        TipPristupa[TipPristupa.ULAZNA_FAKTURA_CRUD],
        TipPristupa[TipPristupa.ULAZNA_FAKTURA_VIEW],
      ]);
      this.shouldDisplayDobavljac = this.shouldDisplayPrimljeniAvans;
    // get router data
    this._route.params.subscribe((params) => {
      if (params['strankaId']) {
        this.strankaId = Number.parseInt(params['strankaId']);
      }
    });
    this.vrstaStrankeOptions = [
      { label: 'Kupac', value: VrstaRacuna.IZLAZNI },
      { label: 'Dobavljač', value: VrstaRacuna.ULAZNI },
    ]
    this._load();
    this.innerWidth = window.innerWidth;
  }

  handleOnItemChange(event: any) {

  }

  openDialog(formType: Type<SlanjePodsetnikaFormComponent>): void {
    const ref = this._dialogService.open(formType, this.dialogConfig);
    this._subs.add(
      ref.onClose.subscribe((dto: any) => {
        if (dto) {
        }
      })
    );
  }

  private _load() {
    this._subs.add(
      this._client.getStrankaInfo(this.strankaId).subscribe((res) => {
        this.strankaInfoDto = res.data;
        if (this.strankaInfoDto.jeKupac) {
          this.vrstaStrankeCtrl = new FormControl(VrstaRacuna.IZLAZNI);
        } else {
          this.vrstaStrankeCtrl = new FormControl(VrstaRacuna.ULAZNI);
        }
        this.setBr();
      })
    );
  }

  private setBr() {
    this._breadcrumbService.set('@nazivStranke', this.strankaInfoDto.naziv);
    this._breadcrumbService.set('@PravnoLiceId', this.strankaInfoDto.naziv);
  }
  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  public readonly VrstaRacuna = VrstaRacuna;
}
